export default __webpack_public_path__ + "static/body-cee0b5c269cf6f71a0c035719a80f02e.png";